import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';
import { reduxKey } from '../../types/customBoxTemplates';

export const fetchMoreCustomboxTemplates = createCallbackActionCreator(
  `${reduxKey}.FETCH_MORE_CUSTOMBOX_TEMPLATES`
);
